if( document.querySelectorAll('[js-action-quick-add]').length > 0 ){
  document.querySelectorAll('[js-action-quick-add]').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      let quickaddHtml;
      if(target.target.closest('.SuggestionItemsList_Interior')){
        quickaddHtml = target.target.closest('.SuggestionItemsList_Interior').querySelector('.rainforest__quickadd_drawer').innerHTML;
      }else if(target.target.closest('.groups_quick__grid-item')){
        quickaddHtml = target.target.closest('.groups_quick__grid-item').querySelector('.rainforest__quickadd_drawer').innerHTML;
      }
      document.querySelector('[js-quick-add-layout-setup]').innerHTML = `<div class="rainforest__quickadd_drawer" data-snippet-type="rainforest-pdp-quick-add-drawer">${quickaddHtml}</div>`;
      document.querySelector('[js-quick-add-layout-setup]').querySelector('.rainforest__quickadd_drawer').classList.add('active'); 
      document.querySelector('.page-blury-overlay').classList.add('is-visible-mobile');
      document.body.classList.add('scrollOff-quickadd');        
    })
  })
} 

class PurchaseSelectionQuickadd extends HTMLElement{
  constructor(){
    super();
    this.querySelectorAll('.quickadd__selection_way input[type="radio"]').forEach((elm)=>{
      elm.addEventListener('change', ()=>{
        this.updateRadioOption();
      })
    })
    this.querySelectorAll('.quickadd__subscriptionOption input[type="radio"]').forEach((elm)=>{
      elm.addEventListener('change', ()=>{
        this.updateRadioOption();
      })
    })  
    this.querySelector('.quick__add__action-button .product-form__submit').addEventListener('click', (target)=>{
      target.preventDefault();
      this.updateRadioOption();this.quickaddAction();
    })
    this.querySelectorAll('[js-close-quick-add]').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        document.querySelector('.page-blury-overlay').classList.remove('is-visible-mobile');
        document.body.classList.remove('scrollOff-quickadd');      
        document.querySelector('[js-quick-add-layout-setup]').innerHTML = ``;
      })
    })        
  }
  updateRadioOption(){
    this.updateOptions();
    this.updateMasterId();
    this.updatequickadd();
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('.quickadd__selection_way input[type="radio"]:checked'), (input) => input.value);
  }   
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }   
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  // edited by Skio
  getProductData() {
    return this.productData ||= JSON.parse(this.querySelector('[data-product]').textContent);
  }  
  updatequickadd() {
    if(this.currentVariant){
      this.comparePrice = (this.currentVariant.compare_at_price > this.currentVariant.price) ? ((this.currentVariant.compare_at_price / 100).toFixed(2)) : ((this.currentVariant.price / 100).toFixed(2));
      this.normalPrice = (this.currentVariant.price / 100).toFixed(2);
      if( this.currentVariant.selling_plan_allocations[0] ){
        this.selling_plan_price = (this.currentVariant.selling_plan_allocations[0].price / 100).toFixed(2);
      }
      if( this.currentVariant.compare_at_price > this.currentVariant.price ){
        if( this.querySelector('.quickadd__onetimeSelection') ){
          this.querySelector('.quickadd__onetimeSelection').querySelector('.SubscriptionOptionPrice').innerHTML = `<span class="SubscriptionQuickPrice discounted_price_quickadd">$${this.normalPrice}</span><span class="SubscriptionQuickPrice"><s>$${this.comparePrice}</s></span>`
        }
        if( this.querySelector('.quickadd__SubscribeSelection') && this.currentVariant.selling_plan_allocations[0] ){
          this.querySelector('.quickadd__SubscribeSelection').querySelector('.SubscriptionOptionPrice').innerHTML = `<span class="SubscriptionQuickPrice discounted_price_quickadd">$${this.selling_plan_price}</span><span class="SubscriptionQuickPrice"><s>$${this.comparePrice}</s></span>`
        }
        if( this.currentVariant.available ){
          if( this.querySelector('.quickadd__subscriptionOption input[type="radio"]:checked').value == 'one-time'){
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Add to Cart —&nbsp; $${this.normalPrice} &nbsp;<s>$${this.comparePrice}</s></span>`;
          }else{
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Add to Cart —&nbsp; $${this.selling_plan_price} &nbsp;<s>$${this.comparePrice}</s></span>`;
          } 
          this.querySelector(`.product-form__submit[type="submit"]`).disabled = false;
        }else{
          if( this.querySelector('.quickadd__subscriptionOption input[type="radio"]:checked').value == 'one-time'){
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Sold Out —&nbsp; $${this.normalPrice} &nbsp;<s>$${this.comparePrice}</s></span>`;
          }else{
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Sold Out —&nbsp; $${this.selling_plan_price} &nbsp;<s>$${this.comparePrice}</s></span>`;
          } 
          this.querySelector(`.product-form__submit[type="submit"]`).disabled = true;
        }
      }else{
        if( this.querySelector('.quickadd__onetimeSelection') ){
          this.querySelector('.quickadd__onetimeSelection').querySelector('.SubscriptionOptionPrice').innerHTML = `<span class="SubscriptionQuickPrice"><span class="SubscriptionQuickPrice">$${this.normalPrice}</span></span>`
        }
        if( this.querySelector('.quickadd__SubscribeSelection') && this.currentVariant.selling_plan_allocations[0] ){
           this.querySelector('.quickadd__SubscribeSelection').querySelector('.SubscriptionOptionPrice').innerHTML = `<span class="SubscriptionQuickPrice discounted_price_quickadd">$${this.selling_plan_price}</span><span class="SubscriptionQuickPrice"><s>$${this.comparePrice}</s></span>`
        }
        if( this.currentVariant.available ){
          if( this.querySelector('.quickadd__subscriptionOption input[type="radio"]:checked').value == 'one-time' ){
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Add to Cart —&nbsp; $${this.normalPrice} &nbsp;</span>`;
          }else{
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Add to Cart —&nbsp; $${this.selling_plan_price} &nbsp;<s>$${this.comparePrice}</s></span>`;
          }
          this.querySelector(`.product-form__submit[type="submit"]`).disabled = false;
        }else{
          if( this.querySelector('.quickadd__subscriptionOption input[type="radio"]:checked').value == 'one-time' ){
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Sold Out —&nbsp; $${this.normalPrice} &nbsp;</span>`;
          }else{
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Sold Out —&nbsp; $${this.selling_plan_price} &nbsp;<s>$${this.comparePrice}</s></span>`;
          } 
          this.querySelector(`.product-form__submit[type="submit"]`).disabled = true;
        }
      }
      
      if( this.querySelector('.quickadd__subscriptionOption input[type="radio"]:checked').value == 'one-time' ){
        this.querySelectorAll('.quick__ad__Serving_name').forEach((elm)=>{
          if( elm.querySelector('.for__subscribe_serving') ){ elm.querySelector('.for__subscribe_serving').classList.add('hidden'); }
          if( elm.querySelector('.for__onetime_serving') ){ elm.querySelector('.for__onetime_serving').classList.remove('hidden'); }
        })
        this.querySelectorAll('.quickadd__details_servingDetails').forEach((elm)=>{
          if( elm.querySelector('.subTimedtl') ){ elm.querySelector('.subTimedtl').classList.add('hidden'); }
          if( elm.querySelector('.oneTimedtl') ){ elm.querySelector('.oneTimedtl').classList.remove('hidden'); }
        })
      }else{
        this.querySelectorAll('.quick__ad__Serving_name').forEach((elm)=>{
          if( elm.querySelector('.for__subscribe_serving') ){ elm.querySelector('.for__subscribe_serving').classList.remove('hidden'); }
          if( elm.querySelector('.for__onetime_serving') ){ elm.querySelector('.for__onetime_serving').classList.add('hidden'); }
        }) 
        this.querySelectorAll('.quickadd__details_servingDetails').forEach((elm)=>{
          if( elm.querySelector('.subTimedtl') ){ elm.querySelector('.subTimedtl').classList.remove('hidden'); }
          if( elm.querySelector('.oneTimedtl') ){ elm.querySelector('.oneTimedtl').classList.add('hidden'); }
        })        
      }

      if( this?.querySelector('.SubscriptionOptionDelivery')?.querySelector(`[data-supply-v="${this.currentVariant.title.trim()}"]`) ){
        this.querySelectorAll('.SubscriptionOptionDelivery mt').forEach((mt)=>{ mt.classList.add('hidden'); })
        this.querySelector('.SubscriptionOptionDelivery').querySelector(`[data-supply-v="${this.currentVariant.title.trim()}"]`).classList.remove('hidden');
      }
      
    }
  }
  quickaddAction(){
    if( this.querySelector('.quickadd__subscriptionOption input[type="radio"]:checked').value == 'one-time' ){
      this.querySelector('.product-form__submit[name="add"]').classList.add('loading');
      this.querySelector('.product-form__submit[name="add"]').disabled = true;
      this.productVariantId = this.currentVariant.id,
      this.bundleCart = {
        'items': []
      },        
      this.cartDrawer = document.querySelector("cart-drawer");
      if (this.cartDrawer) document.querySelector("cart-drawer").enableLoading();
      this.cartItem = {
        id: this.productVariantId,
        quantity: 1,
      };
      this.bundleCart.items.push(this.cartItem);
      this.bundleCart.sections = this.cartDrawer.getSectionsToRender().map((section) => section.section);
      this.bundleCart.sections_url = window.location.pathname      
      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(this.bundleCart),
          credentials: 'same-origin'
      }).then((response) => response.json())
      .then((parsedState) => {
        this.cartDrawer.renderContent(parsedState.sections);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (this.cartDrawer) {
          document.querySelector("cart-drawer").disableLoading();
          document.querySelector("cart-drawer").open();
        }
        this.querySelector('.product-form__submit[name="add"]').classList.remove('loading');
        this.querySelector('.product-form__submit[name="add"]').disabled = false;
        document.querySelector('.page-blury-overlay').classList.remove('is-visible-mobile');
        document.body.classList.remove('scrollOff-quickadd');
        document.querySelectorAll('.rainforest__quickadd_drawer').forEach((elm)=>{elm.classList.remove('active')});  
        const items_grid_detect = document.querySelectorAll('.groups_quick__grid-item');
        if (items_grid_detect.length) { items_grid_detect.forEach(el => el.classList.remove('active')) }         
      }); 
    }else{
      this.querySelector('.product-form__submit[name="add"]').classList.add('loading');
      this.querySelector('.product-form__submit[name="add"]').disabled = true;
      this.productVariantId = this.currentVariant.id;
      // Filter to only use selling plans from app_id 5859381
      // edited by Skio
      const productData = this.getProductData();
      const filteredSellingPlanGroups = productData.selling_plan_groups.filter(selling_plan_group => 
        selling_plan_group.app_id === '5859381'
      );
      
      // Get valid selling plan IDs from filtered groups
      const validPlanIds = new Set();
      filteredSellingPlanGroups.forEach(group => {
        if (group.selling_plans) {
          group.selling_plans.forEach(plan => validPlanIds.add(plan.id));
        }
      });
      
      // Find first matching allocation
      const validAllocation = this.currentVariant.selling_plan_allocations.find(allocation =>
        validPlanIds.has(allocation.selling_plan_id)
      );
      
      if (validAllocation) {
        this.ProductSellingId = validAllocation.selling_plan_id;
      } else {
        console.warn('No selling plan allocations found for app_id 5859381');
        this.ProductSellingId = this.currentVariant.selling_plan_allocations[0].selling_plan_id; // fallback
      }
      // edited by Skio
      this.bundleCart = {
        'items': []
      },        
      this.cartDrawer = document.querySelector("cart-drawer");
      if (this.cartDrawer) document.querySelector("cart-drawer").enableLoading();
      this.cartItem = {
        id: this.productVariantId,
        quantity: 1,
        selling_plan:this.ProductSellingId,
      };
      this.bundleCart.items.push(this.cartItem);
      this.bundleCart.sections = this.cartDrawer.getSectionsToRender().map((section) => section.section);
      this.bundleCart.sections_url = window.location.pathname      
      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(this.bundleCart),
          credentials: 'same-origin'
      }).then((response) => response.json())
      .then((parsedState) => {
        this.cartDrawer.renderContent(parsedState.sections);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (this.cartDrawer) {
          document.querySelector("cart-drawer").disableLoading();
          document.querySelector("cart-drawer").open();
        }
        this.querySelector('.product-form__submit[name="add"]').classList.remove('loading');
        this.querySelector('.product-form__submit[name="add"]').disabled = false;
        document.querySelector('.page-blury-overlay').classList.remove('is-visible-mobile');
        document.body.classList.remove('scrollOff-quickadd');
        document.querySelectorAll('.rainforest__quickadd_drawer').forEach((elm)=>{elm.classList.remove('active')});
        const items_grid_detect = document.querySelectorAll('.groups_quick__grid-item');
        if (items_grid_detect.length) { items_grid_detect.forEach(el => el.classList.remove('active')) }        
      });         
    }
  }
}
customElements.define('cus-quick-add',PurchaseSelectionQuickadd)